module.exports = __webpack_public_path__ + "static/media/arrowDown.9b4e2f84.svg";